import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { MODAL_CUSTOM_MESSAGE, Selected_Index, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { costCenterActions } from "../../../../store/external/finance/cost-code.reducer";
import ModalContainer from "../../../common/modal/modal-container/modal-container.component";
import CostAllocationForm from "./modal-form/cost-allocation-form/cost-allocation-form.component";
import DetailContainer from "../../../common/Layout/details/DetailsLayout.component";
import CostAllocationHistoryLayout from "./modal-form/cost-allocation-form/history/cost-allocation-history-layout.component";
import { TRANSLATIONS as translation } from "../../../../utils/constant.utils";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ConfirmationModal } from "../../../common/modal/modal.component";
import { NotificationModal } from "../../../common/modal/notification-modal.component";
import { isObjectEqual } from "../../../../utils/helpers.utils";

class CostCenter extends Component {
    constructor(props) {
        super(props);
        this.displaySearchBox = this.displaySearchBox.bind(this)
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            detailsView: false,
            employeeId: 0,
            userId: 0,
            showModalForm:false,
            contentIndex:  Selected_Index.i_Zero,
            activeTab: Selected_Index.i_Zero, 
            showModal: false,
            isNew:false,
            costCenterId:0,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            confirmationModal: {
                title: "",
                messageBody: "",
                confirmAction: () => {}
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
        }
        this.ConfirmationModal = React.createRef();
    }
    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractCostCenter();
            
        }
    };

    componentDidMount() {
        this.getCostcenterDetails();
    }

    componentWillUnmount() {
        this.props.setDefaultCostCenter();
        this.props.getCostCenter(0, true);
    }

    getCostcenterDetails(){
        const { getCostCenter, getCostCenterDropdownList } = this.props
        getCostCenter();
        getCostCenterDropdownList();
    }

    displaySearchBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    resizePage = (value) => {
        const { getCostCenter, resizeCostCenterPage } = this.props;
        resizeCostCenterPage(value);
        getCostCenter();
    }
   
    loading = () => {
        return (
            <NoSubscription />
        );
    }
    applyFilter = (isApply, isReset = false) => {
        const { getCostCenter, applyCostCenterFilter, costCenter } = this.props;
        isApply = isApply && costCenter.costCenterTableFilterList.length;
        applyCostCenterFilter(isApply);
        (isApply || isReset || !costCenter.costCenterTableFilterList.length) && getCostCenter();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }
    
    handleRowClick = async (data) => {
       const { getCostCenterForm } = this.props
       await getCostCenterForm(data);
        this.setState({
            showModalForm: true,
            costCenterId: data.CostCodeId
        });
    
    }

    handleCreateNewAction=()=>{
        this.setState({
            showModal: true,
        })        
    }

    handleCreateNewConf(buttonType){
        const { getCostCenterForm } = this.props
        if(buttonType==="ok")
        {
            getCostCenterForm();
            this.setState({showModalForm:true,showModal: false,isNew: true })
        } else {
            this.setState({showModal: false })
        }
       
     }

    handleCloseFormModal = () => {
        this.setState({showModalForm:false,contentIndex:Selected_Index.i_Zero, isNew:false});
        this.props.setResetCostCenterAuthorizeList();
    }

    handleSelectedIndex = (index) =>{
        this.setState({contentIndex: index})      
    }

    onClickSaveModal = async (costCenterId, validate = 1) => {
        const { saveCostCenterForm, financeCostCodeForm, getCostCenterForm, getCostCenter } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await saveCostCenterForm(costCenterId, validate);
        this.setState({
            isSaving: false
        });

        if(result.success)
        {
            if(result.isValid)
            {
                const confirmMessage = "Are you sure you want to save?";
                const modalTitle = this.toLocaleLanguage("call_save", false);
                var confirmAction = () => this.onClickSaveModal(financeCostCodeForm.costCenterId, 0)
                this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                return
            }
            else{
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title", false), result.message);

                const data = result.data;
                getCostCenterForm(data);
                getCostCenter();
                this.setState({costCenterId:data.costCenterId, isNew:false})
            }
        }
        else
        {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
            return;
        }
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    render() {
        const { costCenter, getCostCenter, sortCostCenterItems, setCostCenterColSearchStr, addCostCenterFilter, removeCostCenterFilter, financeCostCodeForm, $form } = this.props
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceCostAllocationDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceCostAllocationDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceCostAllocationDashboardRW])

        const { contentIndex } = this.state;

        const initialRequired = financeCostCodeForm.costCenter === '' || financeCostCodeForm.costCenter == null ||
                                financeCostCodeForm.status === '' || financeCostCodeForm.status == null 
        
        const disableSaveChanges = isObjectEqual($form.value, financeCostCodeForm) ? true : false || !financeCostCodeForm.costCenter;

        return (
            <>
            <DetailsDashboard 
            // Filter Properties
            data={costCenter.costCenterItems.TableFilterData} 
            translation={""} 
            addAction={addCostCenterFilter} 
            removeAction={removeCostCenterFilter} 
            applyAction={this.applyFilter}
            isCreateButtonHidden={!this.props.costCenter.isCostCenterLoaded}
            isCustomColumns={true}
            customClassName={"cost-allocation"}

                //Create New
            createNewAction={this.handleCreateNewAction}
            //View Search Textbox
            viewSearchAction={this.displaySearchBox}

                //Customize Column
                firstList={null} 
                secondList={null} 
                defaultList={null} 
                saveAction={()=>{}}

                //Extract Button
                extractAction={(e) => this.onClickExtract(e)}

                //Access Type
                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}
                >
                {this.props.costCenter.isCostCenterLoaded ?
                    <TablePagination  
                        key={TABLE_PAGINATION_KEY.CostCode}
                        classNameWrapper="overflow-auto"
                        columns={costCenter.costCenterItems.Headers}
                        pageList={costCenter.costCenterItems.Data}
                        pages={costCenter.costCenterItems.Pagination}
                        rowClickAction={(item) => {this.handleRowClick(item)}}
                        paginationAction={getCostCenter}
                        onColumnClick={sortCostCenterItems}
                        onColumnSearch={() => { getCostCenter(0) }}
                        onColumnSearchChange={setCostCenterColSearchStr}
                        isColSearchShow={this.state.displaySearch}
                        resizePage={this.resizePage}
                        totalPage={costCenter.costCenterItems.Pagination.TotalEntries}
                        hideStatusIcon={true}
                    />
                : this.loading()}
            </DetailsDashboard>
                <ConfirmationNotificationModal 
                    show={this.state.showModal} 
                    message={MODAL_CUSTOM_MESSAGE.create_new_cost_center} 
                    title={'Add New'}
                    handleModal={this.handleCreateNewConf.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                
                <ModalContainer
                    title="cost_center" 
                    show={this.state.showModalForm} 
                    handleModal={this.handleCloseFormModal} 
                    hideBtn={contentIndex === Selected_Index.i_One || !costCenter.isFetchFormLoaded? true : false}
                    saveDetails={this.onClickSaveModal}
                    customClass="cost-allocation-details__modal modal-form__container"
                    disabled={this.state.isNew ? initialRequired : disableSaveChanges}

                    //Access Type
                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}
                >
                    <div className="data-table">
                        <DetailContainer
                            renderTabContent={this.handleSelectedIndex}
                            urlIndex={this.state.activeTab}
                            listTab={[
                                {
                                    "id": Selected_Index.i_Zero,
                                    "label": "Details",
                                    "hidden": false
                                },
                                {
                                    "id": Selected_Index.i_One,
                                    "label": "History",
                                    "hidden": false,
                                    "disable": this.state.isNew
                                },

                            ]}
                        >
                            {contentIndex === Selected_Index.i_Zero && <CostAllocationForm />}
                            {contentIndex === Selected_Index.i_One &&
                                <CostAllocationHistoryLayout
                                    costCodeId={costCenter.costCenterDetails.costCenterId}
                                    hideCustomColumn={true}
                                    //Access Type
                                    isReadOnly={isReadOnly}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                />}
                        </DetailContainer>
                    </div>
                </ModalContainer> 

                <ConfirmationModal
                    ref={this.ConfirmationModal}
                    title={this.state.saveModal.title}
                    messageBody={this.state.saveModal.messageBody}
                    confirmAction={this.state.saveModal.confirmAction}
                    closeLabel={this.toLocaleLanguage("cancel_button")}
                    confirmLabel={this.toLocaleLanguage("yes_button")}
                    disabled={this.state.isSaving}
                />
            
                <NotificationModal
                    show={this.state.saveNotif.show}
                    title={this.state.saveNotif.title}
                    message={this.state.saveNotif.message}
                    handleModal={() => this.toggleSaveNotif(false)}
                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                />
            </>
        );
    }
}
export default withRouter(connect(
    state => {
        const { costCenter,
                form:{ forms:{ financeCostCodeForm:{ $form } } }
         } = state;
        const { financeCostCodeForm } = state.form;
        return {
            financeCostCodeForm
            , costCenter
            , translation
            , $form
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, costCenterActions),
        dispatch
    )
)(CostCenter));